var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHayCut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1756_19456",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14V14H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1756_19456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1406 11.4825C11.6028 12.1531 10.9164 12.549 10.1992 12.549C8.40213 12.549 6.94531 10.0638 6.94531 6.99817C6.94531 3.93255 8.40213 1.44739 10.1992 1.44739C11.9963 1.44739 13.4531 3.93255 13.4531 6.99817C13.4531 7.88192 13.313 8.71746 13.0977 9.45911",
    stroke: "#378440",
    strokeWidth: 1.09375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48828 7.12476C9.30193 7.12476 9.13281 6.64867 9.13281 6.06138",
    stroke: "#378440",
    strokeWidth: 1.09375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1855 3.96326C10.9331 3.96326 11.4844 5.46716 11.3203 7.79138C11.1544 10.1414 10.0991 12.2758 9.35156 12.2758",
    stroke: "#378440",
    strokeWidth: 1.09375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13281 6.06201C9.13281 4.7532 9.77025 3.96565 10.1855 3.96565",
    stroke: "#378440",
    strokeWidth: 1.09375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75781 7.00183C4.75781 3.93621 5.9412 1.45105 7.73828 1.45105",
    stroke: "#378440",
    strokeWidth: 1.09375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1992 1.45459H3.80078C2.0037 1.45459 0.546875 3.93975 0.546875 7.00537C0.546875 10.071 2.0037 12.5562 3.80078 12.5562H10.1992",
    stroke: "#378440",
    strokeWidth: 1.09375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.76562 7.00549C2.76562 10.0711 4.76932 12.5563 6.56641 12.5563",
    stroke: "#378440",
    strokeWidth: 1.09375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHayCut);
export default __webpack_public_path__ + "static/media/Hay-cut.d9e075e39b36978e39d11ee4cd0f6d50.svg";
export { ForwardRef as ReactComponent };